// The i18n side of `game/seatWinds.ts` — one seat's wind as display copy.
// Split from the rule itself so the rule stays canvas- and locale-free, and so
// the match HUD and the hand-end modal cannot drift apart again: both name a
// seat through this, and `render/TableRenderer.ts`'s compass letter comes off
// the same `seatWind` call.

import { seatWind, type Wind } from '../game/seatWinds.js';
import type { Seat } from '../game/types.js';
import { t } from '../i18n/I18n.js';

const WIND_KEY = {
  east: 'game.seatEast',
  south: 'game.seatSouth',
  west: 'game.seatWest',
  north: 'game.seatNorth',
} as const satisfies Record<Wind, string>;

/** `seat`'s wind this hand, as display copy. `dealer` is who is dealing — the
 *  winds rotate with them, so passing the wrong one silently renames the table. */
export function windLabel(seat: Seat, dealer: Seat): string {
  return t(WIND_KEY[seatWind(seat, dealer)]);
}
